"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fdate = void 0;
var fdatetime_1 = require("./fdatetime");
/**
 * formatuje datę do formatu yyyy-MM-dd
 * @param dt data typu Date
 */
function fdate(dt) {
    if (!isNaN(dt.getTime())) {
        return fdatetime_1.formatDateFunction['yyyy-MM-dd'](dt);
    }
    return '';
}
exports.fdate = fdate;
exports.default = fdate;
//# sourceMappingURL=fdate.js.map